import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

export type ModalApi = {
	showModal(content: ReactNode): Promise<boolean>;
	cancelModal(): void;
	confirmModal(): void;
};
export const ModalContext = createContext<ModalApi | undefined>(undefined);
export const useModal = () => {
	const ctx = useContext(ModalContext);
	if (!ctx) {
		throw new Error('no modal context found');
	}
	return ctx;
};
